import { ApiUtility } from "../Utilities/ApiUtility.axios";

export enum FyiImportJobStatus {
  Pending = 1,
  InProgress = 2,
  Completed = 3,
  Failed = 4,
  Cancelled = 5,
}

export interface IFyiImportJob {
  id: string;
  practiceId: number;
  bucketName: string;
  region: string;
  awsAccessKeyId: string;
  awsSecretAccessKey: string;
  s3Prefix?: string;
  status: FyiImportJobStatus;
  totalCount: number;
  maxConcurrency?: number;
  targetClientId?: string;
  successCount: number;
  skipCount: number;
  errorCount: number;
  startedOn?: string;
  completedOn?: string;
  errorDetails?: string;
}

export interface IFyiImportJobRequest {
  practiceId: number;
  bucketName: string;
  region: string;
  awsAccessKeyId: string;
  awsSecretAccessKey: string;
  s3Prefix?: string;
  maxConcurrency?: number;
  targetClientId?: string;
}

class FyiImportService {
  route = "api/FyiImport";

  getList = (start: number, length: number, search?: string) =>
    ApiUtility.get(this.route, { start, length, search });

  create = (data: IFyiImportJobRequest) =>
    ApiUtility.post(this.route, data);

  update = (id: string, data: IFyiImportJobRequest) =>
    ApiUtility.put(`${this.route}/${id}`, data);

  cancel = (id: string) =>
    ApiUtility.post(`${this.route}/${id}/Cancel`, {});

  start = (id: string) =>
    ApiUtility.post(`${this.route}/${id}/Start`, {});

  restart = (id: string) =>
    ApiUtility.post(`${this.route}/${id}/Restart`, {});

  getLog = (id: string) =>
    ApiUtility.get<any>(`${this.route}/${id}/Log`);
}

export default new FyiImportService();
